// extracted by mini-css-extract-plugin
export var aircallIframe = "_kz-3";
export var fabContainer = "_kz-5";
export var fabRinging = "_kz-6";
export var loadingOverlay = "_kz-4";
export var pulse = "_kz-7";
export var widgetContent = "_kz-2";
export var widgetPanel = "_kz-0";
export var widgetPanelExpanded = "_kz-1";